/** @typedef {{ key: string, label: string, icon: string, path: string, paths?: string[], permission?: string, action?: string, priority: number, iconTone?: string }} MobileTabItem */

/** @type {MobileTabItem[]} */
export const MOBILE_TABBAR_TABS_CONFIG = [
  {
    key: "home",
    label: "Home",
    icon: "LayoutDashboard",
    path: "/",
    paths: ["/"],
    priority: 1,
    iconTone: "bg-blue-50 text-blue-700",
  },
  {
    key: "vendas",
    label: "Vendas",
    icon: "Receipt",
    path: "/vendas",
    permission: "Vendas",
    action: "islist",
    priority: 3,
    iconTone: "bg-emerald-50 text-emerald-700",
  },
  {
    key: "orcamento",
    label: "Orçamento",
    icon: "Calendar",
    path: "/orcamento",
    paths: ["/orcamento", "/budgetList"],
    priority: 8,
    iconTone: "bg-amber-50 text-amber-700",
  },
  {
    key: "usuarios",
    label: "Usuários",
    icon: "User",
    path: "/usuarios",
    permission: "Usuario",
    action: "islist",
    priority: 9,
    iconTone: "bg-violet-50 text-violet-700",
  },
  {
    key: "configuracoes",
    label: "Configurações",
    icon: "Settings",
    path: "/painel-administrador",
    paths: ["/painel-administrador", "/listConfiguration"],
    permission: "Configuração",
    action: "islist",
    priority: 10,
    iconTone: "bg-slate-100 text-slate-700",
  },
];
